import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchAllPrivateBank } from "./../../api/vietQRApi";

const BankSelector = ({ selectedBank, onBankChange }) => {
  const {
    data: banks,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["banks"], // Include topicId to refetch when it changes
    queryFn: fetchAllPrivateBank, // ✅ Pass function reference
  });

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Chọn ngân hàng
      </label>
      <div className="grid grid-cols-3 gap-3">
        {banks &&
          banks.map((bank) => (
            <button
              key={bank.id}
              type="button"
              onClick={() => onBankChange(bank)}
              className={`flex flex-col items-center p-3 border rounded-lg transition-colors ${
                selectedBank?.id === bank.id
                  ? "border-rose-700 bg-rose-50"
                  : "border-gray-200 hover:bg-gray-50"
              }`}
            >
              <div className="w-32 mb-2 flex items-center justify-center">
                <img
                  src={bank.logo}
                  alt={bank.name}
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <span
                className={`text-sm font-medium ${
                  selectedBank?.id === bank.id
                    ? "text-rose-700"
                    : "text-gray-700"
                }`}
              >
                {bank.name}
              </span>
            </button>
          ))}
      </div>
    </div>
  );
};

export default BankSelector;
